import React from 'react';

class SMOAnalyticsChartCollectionItem extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      title: this.props.title,
      prefix: this.props.prefix,
      amount: this.props.amount,
      unit: this.props.unit,
    };
  }
  
  componentDidMount() {
    this.showChart();
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      title: nextProps.title,
      prefix: nextProps.prefix,
      amount: nextProps.amount,
      unit: nextProps.unit,
    });
    this.showChart();
  }
  
  showChart() {
    let data = [{
      value: 1,
      //date: new Date('2014-11-01'),
      date: '2014-11-01',
    },{
      value: 12,
      //date: new Date('2014-11-02'),
      date: '2014-11-02',
    },{
      value: 10,
      //date: new Date('2014-11-02'),
      date: '2014-11-03',
    },{
      value: 11,
      //date: new Date('2014-11-02'),
      date: '2014-11-04',
    },{
      value: 7,
      //date: new Date('2014-11-02'),
      date: '2014-11-05',
    },{
      value: 8,
      //date: new Date('2014-11-02'),
      date: '2014-11-06',
    },{
      value: 3,
      //date: new Date('2014-11-03'),
      date: '2014-11-07',
    }];
    //data = HTMLWidgets.dataframeToD3(data);
    data = MG.convert.date(data, 'date');
    MG.data_graphic({
        title: "",
        description: "",
        data: data,
        color: '#C7ECF5',
        interpolate: 'basic',
        missing_is_zero: true,
        animate_on_load: true,
        missing_text: 'This is an example of a missing chart',
        xax_format: d3.time.format('%m/%d'),
        width: 560,
        height: 250,
        //right: 40,
        target: '#g'
    });
    
  }
  
  render() {
    return (
      <div className="summary-graph">
        <h4 className="dashboard-title mb20">
          {this.state.title}
          <span className="fr">
            <span className="summary-graph__unit mr5">{this.state.prefix}</span>
            <span className="summary-graph__number summary-graph__up mr5">{this.state.amount}</span>
            <span className="summary-graph__unit mr5">{this.state.unit}</span>
            <span className="summary-graph__difference summary-graph__up">
              <i className="fa fa-arrow-up mr5"></i>
              +<span className="summary-graph__difference-number">10</span>件
            </span>
          </span>
        </h4>
        <div id="g" className="summary-graph__box"></div>
      </div>
    );
  }
}
export default SMOAnalyticsChartCollectionItem;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/analytics/SMOAnalyticsChartCollectionItem.jsx